import { Media, MediaIndex, MediaIndexItem } from "../types/media";

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || "http://localhost:3000").replace(/\/$/, "");

function isVideoIndexItem(item: MediaIndexItem): boolean {
  if (item.contentType?.toLowerCase().startsWith("video/")) {
    return true;
  }
  return /\.(mp4|mov|m4v|webm)$/i.test(item.filename || "");
}

function mediaAssetUrl(
  ownerId: string,
  albumId: string,
  mediaId: string,
  type: "image" | "original" | "video"
): string {
  return `${API_BASE_URL}/api/v1/users/${ownerId}/albums/${albumId}/media/${mediaId}/${type}`;
}

export function hydrateMediaFromIndex(items: MediaIndexItem[], ownerId: string, albumId: string): Media[] {
  return items.map((item) => {
    const video = isVideoIndexItem(item);
    return {
      id: item.id,
      albumId,
      ownerId,
      userId: item.userId || "",
      filename: item.filename,
      contentType: item.contentType,
      metadata: item.takenAt ? { takenAt: item.takenAt } : {},
      url: mediaAssetUrl(ownerId, albumId, item.id, "image"),
      originalUrl: mediaAssetUrl(ownerId, albumId, item.id, "original"),
      playbackUrl: video ? mediaAssetUrl(ownerId, albumId, item.id, "video") : undefined,
      createdAt: item.createdAt,
      updatedAt: item.createdAt,
      version: 0,
    };
  });
}

export function overlayMediaById(indexMedia: Media[], loadedMedia: Media[]): Media[] {
  if (loadedMedia.length === 0) {
    return indexMedia;
  }
  const byId = new Map(loadedMedia.map((item) => [item.id, item]));
  return indexMedia.map((stub) => {
    const full = byId.get(stub.id);
    return full ? { ...stub, ...full } : stub;
  });
}

export function withoutMediaIndexItem(index: MediaIndex | undefined, mediaId: string): MediaIndex | undefined {
  if (!index) {
    return index;
  }
  return {
    items: index.items.filter((item) => item.id !== mediaId),
  };
}
